import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SocialProof from './components/SocialProof';
import ProductsSection from './components/ProductsSection';
import MembershipSection from './components/MembershipSection';
import LeadMagnet from './components/LeadMagnet';
import VideoSection from './components/VideoSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navbar />
      <main>
        <section>
          <HeroSection />
        </section>
        <section>
          <SocialProof />
        </section>
        <section>
          <ProductsSection />
        </section>
        <section>
          <MembershipSection />
        </section>
        <section>
          <LeadMagnet />
        </section>
        <section>
          <VideoSection />
        </section>
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}
